import { CheckboxField } from './CheckboxField'
import { withCheckboxField } from './withCheckboxField'

const ConnectedCheckboxField = withCheckboxField(CheckboxField)

export { ConnectedCheckboxField as CheckboxField }
